import { Component, Input, OnInit } from '@angular/core';
import { Plan, PlanWithLimits, Subscription } from '../shared/models/plans';
import { Observable } from 'rxjs';
import { AccountSettingsService } from '../my-account/account-settings.service';


@Component({
  selector: 'cc-ivr',
  templateUrl: './ivr.component.html',
  styleUrls: ['./ivr.component.scss']
})
export class IvrComponent implements OnInit {
  public subscription$: Observable<Subscription>;
  public isFreePlan: boolean;
  constructor(private accountSettingsService: AccountSettingsService) {}

  ngOnInit() {
    this.subscription$ = this.accountSettingsService.getSubscription();
    this.subscription$.subscribe(plans => {
      const plan = plans.licenses[0].planName;
      this.isFreePlan = plan === 'Free' ? true : false;
    });
  }
}
